import Icon from "@ant-design/icons";
import React from "react";

export default function SortAscIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 4.75C16.75 4.33579 16.4142 4 16 4C15.5858 4 15.25 4.33579 15.25 4.75V15.3401L13.2996 13.2397C13.0177 12.9361 12.5432 12.9186 12.2397 13.2004C11.9361 13.4823 11.9186 13.9568 12.2004 14.2603L15.4487 17.7585C15.4541 17.7644 15.4596 17.7701 15.4652 17.7758C15.4712 17.7819 15.4774 17.788 15.4836 17.7939C15.6181 17.9216 15.7999 18 16 18C16.2001 18 16.3819 17.9216 16.5164 17.7939C16.5226 17.788 16.5288 17.7819 16.5348 17.7758C16.5404 17.7701 16.5459 17.7644 16.5513 17.7585L19.7996 14.2603C20.0814 13.9568 20.0639 13.4823 19.7603 13.2004C19.4568 12.9186 18.9823 12.9361 18.7004 13.2397L16.75 15.3401V4.75ZM4.75 8C4.33579 8 4 8.33579 4 8.75C4 9.16421 4.33579 9.5 4.75 9.5H8.25C8.66421 9.5 9 9.16421 9 8.75C9 8.33579 8.66421 8 8.25 8H4.75ZM4 13C4 12.5858 4.33579 12.25 4.75 12.25H9.25C9.66421 12.25 10 12.5858 10 13C10 13.4142 9.66421 13.75 9.25 13.75H4.75C4.33579 13.75 4 13.4142 4 13ZM4 17.25C4 16.8358 4.33579 16.5 4.75 16.5H11.25C11.6642 16.5 12 16.8358 12 17.25C12 17.6642 11.6642 18 11.25 18H4.75C4.33579 18 4 17.6642 4 17.25Z"
        fill="#344054"
      />
    </svg>
  );
};
